export default __webpack_public_path__ + "static/media/Ballroll_00164.bfcb72fc.png";